import React from 'react';

const JobDetailPerks = props => {
  const { className, title, data = [] } = props;

  return (
    <div className={className}>
      <h2 dangerouslySetInnerHTML={{ __html: title }} />
      <ul>
        {data.map((item, i) => (
          <li key={i}>
            <i>
              <img src={item.thePerksIcon[0].url} alt="icon" />
            </i>
            <p>
              <strong>{item.thePerksTitle}</strong>
              {item.thePerksDescription}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default JobDetailPerks;
